<template>
  <div class="setting-online-chat-overtime">
    <div class="module-item-style">
      <div class="module-item-title chat-overtime-title">
        <div>
          客服无应答时消息设置
        </div>
        <div class="chat-overtime-switch-btn">
          <el-switch
              v-model="noresponse_open"
              @change="saveChange('noresponse_open',noresponse_open)"
              active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="chat-overtime-tips">
        客服一段时间没有响应访客消息时，系统自动向他发送一段消息
      </div>
      <div class="chat-overtime-content" v-if="showContentBox">
        <div class="chat-finish-time-set">
          客服超过 <input min="0" class="chat-finish-num" v-model="noresponse_time" @change="saveChange('noresponse_time',noresponse_time)" type="number"> 秒无响应时自动发送
        </div>
        <el-input
            class="input-textarea"
            type="textarea"
            resize="none"
            rows="4"
            maxlength="250"
            show-word-limit
            @blur="saveChange('noresponse_content',noresponse_content)"
            placeholder="请输入内容..."
            v-model="noresponse_content">
        </el-input>
      </div>
    </div>

    <div class="module-item-style">
      <div class="module-item-title chat-overtime-title">
        离线访客显示时间
      </div>
      <div class="chat-overtime-tips">
        当访客离线超过一定时长，对话页面将不再显示
      </div>
      <div class="chat-overtime-content">
        <div class="chat-finish-time-set">
          离线访客超过 <input min="0" class="chat-finish-num" v-model="offline_time" @change="saveChange('offline_time',offline_time)" type="number"> 分钟后不再显示
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'setting-online-chat-overtime',
    data() {
      return {
        noresponse_open:true,
        noresponse_content:'',
        noresponse_time:'0',
        offline_time:'0',
        showContentBox:false
      }
    },
    created() {
      this.getOvertimeData()
    },
    mounted() {

    },
    methods: {
      getOvertimeData(){
        this.$http.getOvertimeConfigAPI().then( res => {
          if(res.status == 1){
            let data = res.data
            if(data.noresponse_open == 1){
             this.noresponse_open = true
             this.showContentBox = true
            }else {
              this.noresponse_open = false
              this.showContentBox = false
            }
            this.noresponse_time = data.noresponse_time
            this.noresponse_content = data.noresponse_content
            this.offline_time = data.offline_time
          }
        })
      },
      saveChange(name,value){
        let postValue ;
        if(name == 'noresponse_time' && value == ''){
          this.$message({
            message: '保存失败',
            type: 'error',
          })
          return
        }
        if(name == 'offline_time' && value == ''){
          this.$message({
            message: '保存失败',
            type: 'error',
          })
          return
        }
        if(value == ''){
          postValue = ''
        }else {
          if(value == 'true' || value == true){
            postValue = 1
          }else if (value == 'false' || value == false) {
            postValue = 0
          }else {
            postValue = value
          }
        }
        this.$http.saveConfigAPI({
          name,
          value:postValue
        }).then( res => {
          if(res.status == 1){
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.getOvertimeData()
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss">
.setting-online-chat-overtime{
  .chat-overtime-title {
    display: flex;

    .chat-overtime-switch-btn {
      margin-left: auto;
    }
  }

  .chat-overtime-tips {
    color: #999;
    font-size: 12px;
    padding: 12px 0 15px 0;
  }

  .chat-overtime-content {
    .input-textarea {
      width: 600px;
    }
    .chat-finish-time-set{
      color: #666;
      padding: 10px 0 20px;
      font-size: 12px;
    }
    .chat-finish-num{
      width:60px;
      height:40px;
      background:rgba(255,255,255,1);
      border:1px solid rgba(238,238,238,1);
      border-radius:4px;
      outline: none;
      padding: 5px;
      text-align: center;
      margin: 0 5px;
    }
  }
}
</style>
